import PropTypes from 'prop-types';

const DivisionType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

export default DivisionType;



// WEBPACK FOOTER //
// ./client/app/shared/types/division.js